import { useSearchParams } from 'react-router-dom'
import { Button } from '@mui/material'

import { OwnerTransferVerifyModal } from '../owner-transfer-verify-modal'

import { useStyles } from './styles'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IOwnerTransferVerifyButtonProps {
  handleOpen: () => void
  handleClose: () => void
  open: boolean
}

const OwnerTransferVerifyButton = ({
  handleOpen,
  handleClose,
  open,
}: IOwnerTransferVerifyButtonProps) => {
  const classes = useStyles()
  const [searchParams] = useSearchParams()
  const verifyToken = searchParams.get('verify_transfer_ownership_token')

  return (
    <>
      {verifyToken && (
        <div className={classes.buttonWrapper}>
          <Button onClick={handleOpen} size="small" variant="contained">
            <HelperWrapper t="account-users-owner-verification-btn" />
          </Button>
          <OwnerTransferVerifyModal open={open} handleClose={handleClose} />
        </div>
      )}
    </>
  )
}
export { OwnerTransferVerifyButton }
